import type { OrderStatus } from './schemas'

export const ORDER_STATUS_KO = {
  PRE_PAYMENT: '결제전',
  PAYMENT_WAITING: '결제대기',
  PAYMENT_COMPLETED: '결제완료',
  IN_PRODUCTION: '제작중',
  PRODUCTION_COMPLETED: '제작완료',
  IN_DELIVERY: '배송중',
  DELIVERY_COMPLETED: '배송완료',
  CANCELED_BY_USER: '주문취소',
  CANCELED_BY_ADMIN: '주문취소',
} as const satisfies Record<OrderStatus, string>

/***************** 배송지 주소록 *****************/
export const DELIVERY_ADDRESS_MAX = 10
export const DELIVERY_ADDRESS_NAME_MAX_LENGTH = 20
export const DELIVERY_ADDRESS_DETAIL_MAX_LENGTH = 20
